import { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Header } from "../components/Header";
import { Sidebar } from "../components/Sidebar";
import { Availtable } from "./Availtable";
import { Bookingform } from "./Bookingform";
import styles from "./FrontDesk.module.css";

const FrontDesk = () => {
  const hotelId = localStorage.getItem("hotel");
  const [availData, setAvailData] = useState([]);
  const [calendarData, setCalendarData] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <div className={styles.dashboard}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.maincontent}>
          <Header hotelId={hotelId} showCreateBookingBtn={true} />
          <Bookingform setAvailData={setAvailData} hotelId={hotelId} />
          <br />
          <br />
          <Availtable availData={availData} hotelId={hotelId} />
        </div>
      </div>

      <ToastContainer autoClose={1500} />
    </div>
  );
};

export default FrontDesk;
